/**
 * H2C Backend
 * An ASP.NET Core Web API for managing H2C User 
 *
 * The version of the OpenAPI document: V40:2026_08_27_13_13
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { TPostPutPlannedH2Amount } from './tPostPutPlannedH2Amount';


export interface TPostFacilityAndPlannedH2AmountDTO { 
    facility_name?: string | null;
    facility_type_id?: number;
    facility_city?: string | null;
    facility_latitude?: number;
    facility_longitude?: number;
    facility_street?: string | null;
    facility_street_number?: string | null;
    facility_zip_code?: string | null;
    facility_country_id?: number;
    facility_related_vnb_id?: number;
    facility_malo_id?: string | null;
    facility_hydrogen_quality_id?: number;
    facility_hydrogen_utilization_id?: number;
    facility_hydrogen_sector_of_location_id?: number;
    facility_hydrogen_pressure?: number | null;
    facility_description?: string | null;
    facility_plan?: TPostPutPlannedH2Amount;
    facility_owner_email?: string | null;
}

